module.exports = new __parcel__URL__("platinum1.f23806cf.png").toString();